/** @format */

import React, { useState, useEffect, useRef } from 'react';
import DualtechLoader from 'components/global/DualtechLoader';

export default function LoadingModal({
  show,
  loaderSize = 30,
  loaderStyles = {},
  minDisplayTime = 500,
  displayThreshold = 200,
  animate = true
}) {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);
  const displayTimeout = useRef(0);
  const displayStartTime = useRef(0);
  useEffect(() => {
    if (show && !visible && displayStartTime.current === 0) {
      displayStartTime.current = new Date().getTime();
      displayTimeout.current = setTimeout(() => {
        setMounted(true);
        setVisible(true);
      }, displayThreshold);
      return;
    }
    const now = new Date().getTime();
    const displayTime = now - displayStartTime.current;

    if (!show && displayStartTime.current !== 0) {
      if (displayTime < displayThreshold) {
        clearTimeout(displayTimeout.current);
        displayStartTime.current = 0;
        return;
      }
    }
    if (!show && displayStartTime.current !== 0) {
      setTimeout(() => {
        clearTimeout(displayTimeout.current);
        setVisible(false);
        displayStartTime.current = 0;
      }, Math.max(0, displayThreshold + minDisplayTime - displayTime));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  if (!mounted) {
    return null;
  }

  const extraClasses = [visible ? 'show' : 'hide'];
  if (animate) {
    extraClasses.push('animate');
  }

  return (
    <div
      className={`loading-modal ${extraClasses.join(' ')}`}
      onAnimationEnd={() => {
        if (!show && !visible) {
          setMounted(false);
        }
      }}
    >
      <DualtechLoader size={loaderSize} styles={loaderStyles} />
    </div>
  );
}
